var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2",attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-system-bar',{staticClass:"white--text",attrs:{"color":"primary","dark":""}},[_vm._v(" Комментарии по конфигурации ")]),_c('config-comments-list',{attrs:{"project":_vm.receipt}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }